import LTR from "@brand-icons/ploom/ui-copy-outline/ui-copy-outline-ltr.svg";
import RTL from "@brand-icons/ploom/ui-copy-outline/ui-copy-outline-rtl.svg";

import { iconFactory } from "../iconFactory";

export const UiCopyOutlineIcon = iconFactory("UiCopyOutlineIcon", LTR, RTL);
